// @flow
import { call, put, takeLatest } from 'redux-saga/effects';
import { ENTITELEMENTS_ATTRIBUTE, GET_ENTITLEMENTS } from './constants';

import type { GetEntitlementsAction } from './types';
import handleApi from '~/core/state/handle-api';
import handleSaga from '~/core/state/handle-saga';
import type { Effect } from 'redux-saga';
import { noop } from 'lodash/fp';
import { receiveEntitlements } from './actions';
import { user as userApi } from '~/core/api';

export function* getEntitlements({ payload: { userid } }: GetEntitlementsAction): Generator<noop | Effect, *, *> {
    const [response = {}, error] = yield call(handleApi(userApi.getAttribute), userid, ENTITELEMENTS_ATTRIBUTE);
    const is404 = error && error.status === 404;
    yield put(receiveEntitlements(error ? (is404 ? response : error) : response));
}

function* watchGetEntitlements(): Generator<Effect, *, *> {
    yield takeLatest(GET_ENTITLEMENTS, handleSaga(getEntitlements));
}

export default [watchGetEntitlements];



// WEBPACK FOOTER //
// ./src/core/state/entitlements/sagas.js